import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { App } from 'antd';
import { useAuth } from '../../hooks/useAuth.tsx';
import { isTokenExpired } from '../../utils/helpers';
import { ROUTES } from '../../utils/constants';

export const CheckToken = () => {
  const navigate = useNavigate();
  const { authState } = useAuth();
  const { modal } = App.useApp();
  const token = authState?.token;

  useEffect(() => {
    const handleFocus = () => {
      if (token && isTokenExpired(token)) {
        modal.warning({
          title: 'Session Expired',
          content: 'Your session has expired. Please log in again.',
          onOk() {
            navigate(ROUTES.LOGIN);
          },
        });
      }
    };

    window.addEventListener('focus', handleFocus);
    return () => window.removeEventListener('focus', handleFocus);
  }, [modal, navigate, token]);

  return null; // This component does not render anything
};

